import { useUserData } from 'components/user/hooks/use-user-data';
import app from 'srcJs/App';
import * as React from 'react';
import { ReactNode } from 'react';
import { PopoverStickOnHover } from 'components/popover/PopoverStickOnHover';
import classNames from 'classnames';

const UserPanelBalance = () => {
  const userData = useUserData();

  const renderBalance = (): ReactNode => {
    if (!userData.balanceData.hasCreditLimit) {
      return (
        <div className="fs-16 lh-1 font-weight-bold text-dark">
          {userData.balanceData.valueFormat}
        </div>
      );
    }

    return (
      <PopoverStickOnHover
        text={userData.balanceData.tooltip}
        asHtml
        placement="bottom"
        popoverProps={{
          bsPrefix: 'popover popover_full-width',
        }}
      >
        <div
          className={classNames(
            'fs-16 lh-1 font-weight-bold',
            { 'text-danger': userData.balanceData.isNegative },
            { 'text-dark': !userData.balanceData.isNegative },
          )}
        >
          {userData.balanceData.valueFormat}
        </div>
      </PopoverStickOnHover>
    );
  };

  return (
    <div className="dropdown-flat-header__balance">
      {renderBalance()}
      <div className="color-858585 fs-14">
        {app.tForReact('base', 'Balance')}
      </div>
    </div>
  );
};

export { UserPanelBalance };
